/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { css } from '@emotion/react'

import type { UseEuiTheme } from '@elastic/eui'

export const gridContainerCss = (theme: UseEuiTheme) =>
  css({
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
    gridTemplateRows: 'auto auto',

    [`@media screen and (max-width: ${theme.euiTheme.breakpoint.xl}px)`]: {
      gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
      gridTemplateRows: 'auto auto',
    },

    [`@media screen and (max-width: ${theme.euiTheme.breakpoint.m}px)`]: {
      gridTemplateColumns: '1fr',
      gridTemplateRows: 'auto',
    },
  })

export const gridItemCss = (theme: UseEuiTheme) =>
  css({
    gridColumn: 'span 2',

    [`@media screen and (max-width: ${theme.euiTheme.breakpoint.m}px)`]: {
      gridColumn: 'span 1',
    },
  })
